var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPercent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6666 10.0003V14.0336C36.6666 16.667 35 18.3337 32.3666 18.3337H26.6666V6.68363C26.6666 4.83363 28.1833 3.31697 30.0333 3.33363C31.85 3.3503 33.5166 4.08363 34.7166 5.28363C35.9166 6.5003 36.6666 8.16697 36.6666 10.0003Z",
    fill: "#5D89EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 11.6668V35.0002C3.33337 36.3835 4.90004 37.1668 6.00004 36.3335L8.85004 34.2002C9.51671 33.7002 10.45 33.7668 11.05 34.3668L13.8167 37.1502C14.4667 37.8002 15.5334 37.8002 16.1834 37.1502L18.9834 34.3502C19.5667 33.7668 20.5 33.7002 21.15 34.2002L24 36.3335C25.1 37.1502 26.6667 36.3668 26.6667 35.0002V6.66683C26.6667 4.8335 28.1667 3.3335 30 3.3335H11.6667H10C5.00004 3.3335 3.33337 6.31683 3.33337 10.0002V11.6668Z",
    fill: "#B3D5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0527 20.1333C18.136 20.1333 17.386 20.8833 17.386 21.8C17.386 22.7166 18.136 23.4666 19.0527 23.4666C19.9693 23.4666 20.7193 22.7166 20.7193 21.8C20.7193 20.8833 19.9693 20.1333 19.0527 20.1333Z",
    fill: "#5D89EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9505 16.7162C11.8838 16.7162 12.6171 15.9661 12.6171 15.0495C12.6171 14.1328 11.8671 13.3828 10.9505 13.3828C10.0338 13.3828 9.28381 14.1328 9.28381 15.0495C9.28381 15.9661 10.0338 16.7162 10.9505 16.7162Z",
    fill: "#5D89EA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4348 12.9001C19.9515 12.4168 19.1515 12.4168 18.6681 12.9001L9.56819 22.0002C9.08486 22.4835 9.08486 23.2835 9.56819 23.7668C9.81819 24.0168 10.1349 24.1335 10.4515 24.1335C10.7682 24.1335 11.0849 24.0168 11.3349 23.7668L20.4348 14.6668C20.9181 14.1834 20.9181 13.3834 20.4348 12.9001Z",
    fill: "#5D89EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercent);
export default __webpack_public_path__ + "static/media/percent.164510bd.svg";
export { ForwardRef as ReactComponent };